import "core-js/modules/es.function.name";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { ga } from 'helpers/multitrack';
import { StarRating } from '../StarRating/StarRating';
export var VenueListItem = function VenueListItem(_ref) {
  var type = _ref.type,
      activities = _ref.activities,
      imageUrl = _ref.imageUrl,
      name = _ref.name,
      subtitle = _ref.subtitle,
      hood = _ref.hood,
      alias = _ref.alias,
      rating = _ref.rating,
      venueId = _ref.venueId,
      _onClick = _ref.onClick,
      nolink = _ref.nolink,
      _ref$showRatingNumber = _ref.showRatingNumber,
      showRatingNumber = _ref$showRatingNumber === void 0 ? true : _ref$showRatingNumber,
      count = _ref.count;
  var className = "venue-list-item".concat(type === 'no-image' ? ' venue-list-item--no-image' : '');
  var venueContent = React.createElement("div", null, type !== 'no-image' && React.createElement("div", {
    className: "venue-list-item__image"
  }, imageUrl && React.createElement("div", {
    style: {
      backgroundImage: "url(".concat(imageUrl, ")")
    }
  })), React.createElement("h5", {
    className: "mb--"
  }, name, subtitle && " \u2013 ".concat(subtitle)), React.createElement("div", {
    className: "mb-"
  }, rating >= 0 && React.createElement(StarRating, {
    showRatingNumber: showRatingNumber,
    rating: rating,
    count: count
  })), hood && React.createElement("p", {
    className: "venue-list-item__location mb-"
  }, hood), activities && React.createElement("p", {
    className: "text--light"
  }, activities.split(',')[0].trim()));

  if (nolink) {
    return React.cloneElement(venueContent, {
      className: className
    });
  }

  return _onClick ? React.cloneElement(venueContent, {
    onClick: function onClick() {
      return _onClick(venueId);
    },
    className: className
  }) : React.createElement(Link, {
    className: className,
    onClick: function onClick() {
      return ga('Venue Details', "".concat(type, " Click"), name);
    },
    to: "/studios/".concat(alias)
  }, venueContent);
};
VenueListItem.propTypes = {
  type: PropTypes.string,
  venueId: PropTypes.number.isRequired,
  activities: PropTypes.string,
  imageUrl: PropTypes.string,
  name: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  hood: PropTypes.string,
  alias: PropTypes.string.isRequired,
  rating: PropTypes.number,
  onClick: PropTypes.func,
  nolink: PropTypes.bool,
  showRatingNumber: PropTypes.bool,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};